import React from 'react';
import wrap from 'wraptile';
import DeleteDialog from './DeleteDialog';

export type OnDialogClose = (confirm: boolean) => void;

export interface DeleteDialogContainerProps {
    text: string;
    onCloseDialog: OnDialogClose;
}

export const onDialogClick = wrap((onCloseDialog: OnDialogClose, confirm: boolean) => {
    onCloseDialog(confirm);
});

export default function DeleteDialogContainer(props: DeleteDialogContainerProps) {
    const {text, onCloseDialog} = props;
    
    const handleClose = onDialogClick(onCloseDialog, false);
    const handleConfirm = onDialogClick(onCloseDialog, true);
    
    return (
        <DeleteDialog
            text={text}
            onClose={handleClose}
            onConfirm={handleConfirm}
        />
    );
}
